import React from 'react';
import DeliveryLocation from '../../../models/DeliveryLocation';
import Pagination from '../../../models/Pagination';
import { Table, TableBody, TableCell, TableHead, TableRow, CircularProgress, TableContainer, Stack } from '@mui/material';
import PaginationButtons from '../../PaginationButtons';
import { ISTableTitle, ISTableHeaderCell, ISTableRow } from '../../Utils/ISTable';
import { useTranslation } from 'react-i18next';
import { ProvinceListState } from '../../../reducers/province/provinceList';

export const deliverylocationLevel = [1, 0]

export type DeliveryLocationLevel = typeof deliverylocationLevel[number]

export const deliverylocationLevelToDescription = (type: DeliveryLocationLevel): string => {
  switch (type) {
    case 1: return "main"
    case 0: return "other"
  }
  return "not"
}

export const deliveryLocationLevelNamesTranslated = (value: DeliveryLocationLevel, t: (key: string) => string) =>
  t(`${deliverylocationLevelToDescription(value)}`)

export interface Row {
  data: DeliveryLocation
  action?: 'create' | 'update' | 'error';
}

interface Props {
  rows: Row[];
  provinceList: ProvinceListState
  loading: boolean;
  pagination?: Pagination;
  fromIn?: boolean;
  onChangePage?: (page: number) => void;
  onClickInfo?: (deliverylocation: DeliveryLocation) => void;
}

const DeliveryLocations: React.FC<Props> = (props) => {
  const { t } = useTranslation('delivery')
  
  const mapActionToColor = (action?: string) => {
    switch (action) {
      case 'create': return 'green';
      case 'update': return 'yellow';
      case 'error': return 'red';
      default: return 'default';
    }
  }

  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', height: 'inherit', borderRadius: "10px", margin: props.fromIn ? "-10px" : "10px", minWidth: "770px" }}>
     { !props.fromIn && <ISTableTitle title={t('title')}/> }
      <TableContainer sx={{ overflowX: 'auto', height: '100%' }}>
        <Table size="medium" stickyHeader={true}>
          <TableHead >
            <TableRow selected={true}>
              <ISTableHeaderCell>{t('address')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('zipCode')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('locality')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('state')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('phoneNumber')}</ISTableHeaderCell>
              <ISTableHeaderCell>{t('openingHours')}</ISTableHeaderCell>
              {/*<ISTableHeaderCell>{t('level')}</ISTableHeaderCell>*/}
            </TableRow>
          </TableHead>
          <TableBody>
            {!props.loading && props.rows.map((row, index) =>
              <ISTableRow key={index} color={mapActionToColor(row.action)} sx={{ cursor: 'pointer' }}
                onClick={(e) => { e.stopPropagation(); props.onClickInfo && props.onClickInfo(row.data) }}>
                <TableCell>{row.data.domicilio}</TableCell>
                <TableCell>{row.data.codigopostal}</TableCell>
                <TableCell>{row.data.localidad}</TableCell>
                <TableCell>{props.provinceList?.provinces?.find( province => province.codigo_provincia.toString() === row.data.codigo_provincia.toString())?.descripcion}</TableCell>
                <TableCell>{row.data.telefono}</TableCell>
                <TableCell>{row.data.horariodeatencion}</TableCell>
                {/*<TableCell>{deliveryLocationLevelNamesTranslated(row.data.principal, t)}</TableCell>*/}
              </ISTableRow>
            )}
          </TableBody>
        </Table>
        {props.loading &&
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={25} />
          </div>
        }
        {<PaginationButtons pagination={props.pagination} />}
      </TableContainer>
    </Stack>
  );
}

export default DeliveryLocations
